import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SvgIcon from '@mui/material/SvgIcon';

function BoxIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 14.5V1.5C12 0.6875 11.3125 0 10.5 0H1.5C0.65625 0 0 0.6875 0 1.5V14.5C0 15.3438 0.65625 16 1.5 16H10.5C11.3125 16 12 15.3438 12 14.5ZM1.5 15C1.21875 15 1 14.7812 1 14.5V1.5C1 1.25 1.21875 1 1.5 1H10.5C10.75 1 11 1.25 11 1.5V14.5C11 14.7812 10.75 15 10.5 15H1.5Z" />
    </SvgIcon>
  );
}
function CardIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M0 2C0 0.90625 0.875 0 2 0H18C19.0938 0 20 0.90625 20 2V10C20 11.125 19.0938 12 18 12H2C0.875 12 0 11.125 0 10V2Z"
        fill="#525A63"
      />
    </SvgIcon>
  );
}
function TokenIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M7.71875 10.625L7 10.25V9.75C7 9.34375 6.65625 9 6.25 9H6.28125C6.125 8.1875 6 6.84375 6 6H6.75C6.875 6 7 5.90625 7 5.75V5.25C7 5.125 6.875 5 6.75 5H6.21875C6.625 4.53125 6.96875 3.65625 6.96875 3C6.96875 1.34375 5.625 0 3.96875 0C2.3125 0 1 1.34375 1 3C1 3.65625 1.34375 4.53125 1.75 5H1.25C1.09375 5 1 5.125 1 5.25V5.75C1 5.90625 1.09375 6 1.25 6H1.96875C1.96875 6.84375 1.84375 8.1875 1.6875 9H1.75C1.3125 9 1 9.34375 1 9.75V10.25L0.25 10.625C0.09375 10.7188 0 10.9062 0 11.0625V12.5C0 12.7812 0.21875 13 0.5 13H7.5C7.75 13 8 12.7812 8 12.5V11.0625C8 10.9062 7.875 10.7188 7.71875 10.625ZM5 6C5 6.84375 5.125 8.1875 5.25 9H2.71875C2.84375 8.1875 2.96875 6.84375 2.96875 6H5ZM4 1C5.09375 1 6 1.90625 6 3C6 4.125 5.09375 5 4 5C2.875 5 2 4.125 2 3C2 1.90625 2.875 1.03125 4 1ZM7 12H1V11.375L2 10.875V10H6V10.875L7 11.375V12Z" />
    </SvgIcon>
  );
}

const ShapeFilterMenu = (props) => {
  return (
    <Menu
      elevation={0}
      open={props.open}
      anchorEl={props.anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={props.handleRequestClose}
      keepMounted
    >
      <MenuItem onClick={() => props.handleClickFilterShapeType('BOX')}>
        <ListItemIcon>
          <BoxIcon viewBox="0 0 12 16" style={{color: '#525A63', fontSize: 16}} />
        </ListItemIcon>
        <ListItemText primary="Boxes" />
      </MenuItem>
      <MenuItem onClick={() => props.handleClickFilterShapeType('CARD')}>
        <ListItemIcon>
          <CardIcon viewBox="0 0 20 12" style={{color: '#525A63', fontSize: 16}} />
        </ListItemIcon>
        <ListItemText primary="Cards" />
      </MenuItem>
      <MenuItem onClick={() => props.handleClickFilterShapeType('TOKEN')}>
        <ListItemIcon>
          <TokenIcon viewBox="0 0 8 13" style={{color: '#525A63', fontSize: 16}} />
        </ListItemIcon>
        <ListItemText primary="Tokens" />
      </MenuItem>
    </Menu>
  );
};

ShapeFilterMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleRequestClose: PropTypes.func.isRequired,
  handleClickFilterShapeType: PropTypes.func.isRequired,
};

export default ShapeFilterMenu;
